import actions from './actions';

const initState = {
  isCreating: false,
  isSearching: false,
  isUpdating: false,
  isDeleting: false,
};

export default (state = initState, action) => {
  switch (action.type) {
    case actions.CREATE_MEMBER_FILTER:
      return { ...state, isCreating: true };
    case actions.CREATE_MEMBER_FILTER_ENDED:
      return { ...state, isCreating: false };
    case actions.SEARCH_MEMBER_FILTERS:
    case actions.FIND_MEMBER_FILTER:
      return { ...state, isSearching: true };
    case actions.SEARCH_MEMBER_FILTERS_ENDED:
    case actions.FIND_MEMBER_FILTER_ENDED:
      return { ...state, isSearching: false };
    case actions.UPDATE_MEMBER_FILTER:
      return { ...state, isUpdating: true };
    case actions.UPDATE_MEMBER_FILTER_ENDED:
      return { ...state, isUpdating: false };
    case actions.DELETE_MEMBER_FILTERS:
      return { ...state, isDeleting: true };
    case actions.DELETE_MEMBER_FILTERS_ENDED:
      return { ...state, isDeleting: false };
    case actions.GET_MEMBER_FILTER_TRIGGER_RECORD_STATISTICS: {
      return {
        ...state,
        isSearching: true,
      };
    }
    case actions.GET_MEMBER_FILTER_TRIGGER_RECORD_STATISTICS_ENDED: {
      return {
        ...state,
        isSearching: false,
      };
    }
    default:
      return state;
  }
};
